import React, { useState, useEffect } from 'react'
import { Chip, Typography, Box, Button, Avatar } from '@mui/material'
import { useTranslate, useNotify, useRefresh } from 'react-admin'
import { TagsModal } from 'src/components/pages/sales/reservation/logic/modals/TagsModal'
import { handleCreateUpdateTag } from 'src/components/pages/sales/reservation/helper/handleCreateUpdateTag'
import { useCardLoading } from 'src/components/pages/sales/reservation/context/CardLoadingContext'
import { itemServices } from 'src/services/reservation/item/item.service'
import { customAwait } from 'src/components/pages/sales/reservation/helper/customAwait'
import { hasPermissionFunction } from 'src/helper/HasPermission'
import { PERMISSION_ASSIGN, PERMISSION_EDIT } from 'src/helper/Permission'
interface Tag {
  long_name: string
  color: string
  short_name: string
  symbol: string
  id: number
}

interface TagsProps {
  tags: Tag[]
  work_unit_id: number
  item_id: number
}

export const TagsReservation: React.FC<TagsProps> = ({ tags, work_unit_id, item_id }) => {
  const translate = useTranslate()
  const notify = useNotify()
  const refresh = useRefresh()
  const [openTagModal, setOpenTagModal] = useState(false)
  const [loadingButtonCreateTagModal, setLoadingButtonCreateTagModal] = useState(false)
  const [loadingButtonSelectTagModal, setLoadingButtonSelectTagModal] = useState(false)
  const [tagsState, setTagsState] = useState(tags || [])
  const { setCardLoading } = useCardLoading()

  useEffect(() => {
    setTagsState(tags)
  }, [tags])

  const onSubmit = (data: any, cardId: string) => {
    handleCreateUpdateTag(
      data,
      cardId,
      setLoadingButtonCreateTagModal,
      notify,
      refresh,
      setCardLoading,
      work_unit_id
    )
  }

  const onSubmitSelect = (data: any, cardId: string) => {
    handleCreateUpdateTag(
      data,
      cardId,
      setLoadingButtonSelectTagModal,
      notify,
      refresh,
      setCardLoading,
      work_unit_id,
      true
    )
  }

  const handleDelete = async (id: number) => {
    try {
      const new_tags_id = tagsState.map((tag: any) => tag.id).filter((id_tag: any) => id_tag !== id)
      setTagsState(tagsState.filter((tag: any) => tag.id !== id))
      await itemServices.add_tags_in_item(item_id, new_tags_id)
    } catch (error) {
      notify('ra.notification.remove_tag_error', {
        type: 'error',
      })
      setTagsState(tags)
    } finally {
      customAwait([refresh])
    }
  }

  return (
    <Box display={'flex'} justifyContent={'center'} alignItems={'center'}>
      <Box flex={1}>
        {tagsState.length === 0 ? (
          <Typography> {translate('ra.title.empty', { some: 'Tags' })}</Typography>
        ) : (
          tagsState.map((tag, index) => (
            <Chip
              size='medium'
              key={index}
              label={tag.long_name}
              style={{ backgroundColor: tag.color, margin: '3px' }}
              avatar={<Avatar>{tag.symbol}</Avatar>}
              onDelete={
                hasPermissionFunction('item', PERMISSION_EDIT) ? (e) => handleDelete(tag.id) : undefined
              }
            />
          ))
        )}
      </Box>
      <Box width='fit-content'>
        {hasPermissionFunction('tag', PERMISSION_ASSIGN) && (
          <Button onClick={() => setOpenTagModal(true)} variant='contained'>
            {translate('ra.action.add_specific', { name: 'Tags' })}
          </Button>
        )}

        <TagsModal
          open={openTagModal}
          handleClose={() => setOpenTagModal(false)}
          onSubmit={onSubmit}
          onSubmitSelect={onSubmitSelect}
          loadingButtonCreateTagModal={loadingButtonCreateTagModal}
          loadingButtonSelectTagModal={loadingButtonSelectTagModal}
          titleModal={translate('ra.action.add_specific', { name: 'Tags' })}
          work_unit_id={work_unit_id}
          tags_relation={tagsState}
        />
      </Box>
    </Box>
  )
}
